/**
 * @ngdoc directive
 * @module app
 * @name app:videoManager
 * @scope
 * @restrict E
 * @description
 * Sizes videos to ensure they fit on screen and wires up modal event handling.
 * @param {boolean=} fitToScreen Forces the video to fill the viewport. Even if this is false, the video's height will be restricted to ensure the video isn't taller than the viewport.
 * @param {string=} provider The name of the video service the video part of. Used to determine how the video events should be wired up.
 * @param {string=} videoId Unique id used to identify the video.
 */
export default function VideoManagerDirective(moduleName) {
    angular.module(moduleName || 'app')
        .directive('videoManager', videoManager);

    var id = 0;
    videoManager.$inject = ['$window', '$timeout', 'videoProviders'];
    function videoManager($window, $timeout, videoProviders) {
        var directive = {
            restrict: 'A',
            require: '?^^stickyManager',
            scope: true,
            controller: controller,
            bindToController: {
                fitToScreen: '<?',
                videoId: '@?',
                provider: '@?',
                autoplay: '<?',
                loop: '<?'
            },
            controllerAs: 'vm'
        };
        controller.$inject = ['$scope', '$element', '$transclude', '$q'];
        function controller($scope, $element, $transclude, $q) {
            var vm = this;
            vm.$onInit = function () {
                vm._styleName = vm.fitToScreen ? 'height' : 'max-height';
                vm.instanceId = id++;
                vm._clearSlideWatch = $scope.$on('slideChange', function (event, data) {
                    if (vm._provider && vm._provider.ready) {
                        if (data.index === $scope.$parent.$index) {
                            vm._provider.play();
                        }
                        else {
                            vm._provider.pause();
                        }
                    }
                });
            };

            vm.$onDestroy = function () {
                vm._clearSlideWatch();
                vm._win.off('scroll.videoManager' + vm.instanceId).off('resize.videoManager' + vm.instanceId);
            };

            vm.$postLink = function () {
                $timeout(vm.configure);
                vm._win = angular.element($window).on('scroll.videoManager' + vm.instanceId, vm.configure).on('resize.videoManager' + vm.instanceId, vm.configure);
                if (vm.videoId) {
                    vm._provider = videoProviders.get(vm.provider);
                    if (vm._provider !== null) {
                        var target = angular.element('#video-' + vm.videoId);
                        target.on('closed.zf.reveal', function () {
                            vm._provider.stop();
                        }).on('open.zf.reveal', function () {
                            vm.playVideo();
                        });
                        $scope.$on('playVideo', function ($event, id) {
                            if (id === vm.videoId) {
                                vm.playVideo();
                            }
                        });
                        $scope.$on('pauseVideo', function ($event, data) {
                            if (id === vm.videoId) {
                                vm._provider.pause();
                            }
                        });
                        $scope.$on('slideChange', function ($event, data) {
                            if (id === vm.videoId) {
                                vm._provider.pause();
                            }
                        });
                        $scope.$on('closeVideos', function ($event) {
                            if (vm._provider && vm._provider.ready) {
                                vm._provider.stop();
                            }
                        });
                    }
                }
            };

            vm.configure = function () {
                var headerSize = vm.stickyManager ? vm.stickyManager.getStickPoint() : 0;
                //$element.removeAttr('style');
                //$element.css(Foundation.MediaQuery.current === 'small' ? 'max-height' : vm._styleName, 'calc(100vh - ' + headerSize + 'px)');
                if ($scope.autoplay && vm._provider && vm._provider.ready) {
                    var boundingRect = $element[0].getBoundingClientRect();
                    if (boundingRect.bottom > headerSize && boundingRect.top <= $window.innerHeight) {
                        vm._provider.play();
                    }
                    else {
                        vm._provider.pause();
                    }
                }
            };

            vm._loadVideo = function () {
                var deferred = $q.defer();
                if (vm._loaded) {
                    deferred.resolve();
                }
                else {
                    vm._loadState = 'started';
                    var clearLoader = $scope.$on('lazyElementLoaded', function (event, videoId) {
                        if (videoId === vm.videoId) {
                            clearLoader();
                            vm._provider.init('player-' + vm.videoId, vm.loop).then(function () {
                                vm.configure();
                                vm._loaded = true;
                                vm._loadState = 'finished';
                                deferred.resolve();
                            });
                        }
                    });
                    $scope.$broadcast('loadLazyElement', vm.videoId);
                }
                return deferred.promise;
            };

            vm.playVideo = function () {
                if (vm._loadState !== 'started') {
                    vm._loadVideo()
                        .then(function () {
                            vm._provider.play();
                        });
                }
            };
        }

        return directive;
    }

};